export const PopupEventTypes = {
	SURVEY_READY: "SURVEY_READY",
	SET_SURVEY_PARAMETERS: "SET_SURVEY_PARAMETERS",
	SURVEY_COMPLETED: "SURVEY_COMPLETED",
	SURVEY_HEIGHT_CHANGED: "SURVEY_HEIGHT_CHANGED",
	SURVEY_PAGE_CHANGED: "SURVEY_PAGE_CHANGED",
};
